import { atom } from "recoil";

export const playerHidePaywayAddModalStore = atom({
	key: "playerHidePaywayAddModalStore",
	default: {
		show: false,
		loaded: false,
		uid: false,
		group: "",
		date: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
